import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import CONSTANTS from "../../../misc/constants";
import Recents from "./Recents";
import { useSelector } from "react-redux";
import parse from "html-react-parser";

const Home = () => {
  useEffect(() => {
    document.title = `${CONSTANTS.APP_NAME}`;
  }, []);

  const lang = useSelector((store) => store.options.lang);

  return (
    <StyledHome>
      <div className="sect sect-1">
        <div>
          <h1>{lang.data.home.title}</h1>
          <p>{lang.data.home.description}</p>
        </div>

        <img
          src="https://firebasestorage.googleapis.com/v0/b/rauru-91579.appspot.com/o/MeBlue.png?alt=media"
          alt="self-portrait"
          className="my-photo pixel-image"
        />
      </div>
      <div className="sect sect-2">
        <h2>{lang.data.home.recent.title}</h2>
        <Recents />
      </div>
      <div className="sect sect-3">
        {/* Area card Development */}
        <h2>{lang.data.home.areas.title}</h2>
        <div className="areas">
          <div className="area-card">
            <div className="card-title">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/rauru-91579.appspot.com/o/webdev.svg?alt=media"
                alt="webdev"
              />
              <h3>{lang.data.home.areas.web.title}</h3>
            </div>
            <div>
              <div>
                <h4>{lang.data.home.areas.tools_t}</h4>
                <p>{parse(lang.data.home.areas.web.tools)}</p>
              </div>
              <div>
                <h4>{lang.data.home.areas.projects_t}</h4>
                <p>{lang.data.home.areas.web.projects}</p>
              </div>
            </div>
            <div>
              <Link to="/blog/1?category=Web_Development" className="btn">
                {lang.data.home.areas.more}
              </Link>
            </div>
          </div>
          {/* Fin area card Development */}
          {/* Area card 3D modeling */}
          <div className="area-card">
            <div className="card-title">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/rauru-91579.appspot.com/o/3D.svg?alt=media"
                alt="3D"
              />
              <h3>{lang.data.home.areas.model3d.title}</h3>
            </div>
            <div>
              <div>
                <h4>{lang.data.home.areas.tools_t}</h4>
                <p>{parse(lang.data.home.areas.model3d.tools)}</p>
              </div>
              <div>
                <h4>{lang.data.home.areas.projects_t}</h4>
                <p>{lang.data.home.areas.model3d.projects}</p>
              </div>
            </div>
            <div>
              <Link to="/blog/1?category=3D_Modeling" className="btn">
                {lang.data.home.areas.more}
              </Link>
            </div>
          </div>
          {/* Fin area card 3D modeling */}
          {/* Area card Pixel Art */}
          <div className="area-card">
            <div className="card-title">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/rauru-91579.appspot.com/o/pixel.svg?alt=media"
                alt="pixel"
              />
              <h3>{lang.data.home.areas.pixel.title}</h3>
            </div>
            <div>
              <div>
                <h4>{lang.data.home.areas.tools_t}</h4>
                <p>{parse(lang.data.home.areas.pixel.tools)}</p>
              </div>
              <div>
                <h4>{lang.data.home.areas.projects_t}</h4>
                <p>{lang.data.home.areas.pixel.projects}</p>
              </div>
            </div>
            <div>
              <Link to="/blog/1?category=Pixel_Art" className="btn">
                {lang.data.home.areas.more}
              </Link>
            </div>
          </div>
          {/* Fin area card  Pixel Art */}
          {/* Area card Desarrollo de Juegos */}
          <div className="area-card">
            <div className="card-title">
              <img
                src="https://firebasestorage.googleapis.com/v0/b/rauru-91579.appspot.com/o/gamedev.svg?alt=media"
                alt="gamedev"
              />
              <h3>{lang.data.home.areas.game.title}</h3>
            </div>
            <div>
              <div>
                <h4>{lang.data.home.areas.tools_t}</h4>
                <p>{parse(lang.data.home.areas.game.tools)}</p>
              </div>
              <div>
                <h4>{lang.data.home.areas.projects_t}</h4>
                <p>{lang.data.home.areas.game.projects}</p>
              </div>
            </div>
            <div>
              <Link to="/blog/1?category=Game_Development" className="btn">
                {lang.data.home.areas.more}
              </Link>
            </div>
          </div>
        </div>
        {/* Fin area card Development */}
      </div>
      <div className="sect sect-4">
        <hr />
        <h2>{lang.data.home.contact.title}</h2>
        <Link to="/contact" className="btn">
          {lang.data.home.contact.talk}
        </Link>
      </div>
    </StyledHome>
  );
};

const StyledHome = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 2rem;
  .sect {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;

    @media (min-width: 992px) {
      padding: 4rem;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
    }
  }

  .sect-1 {
    padding-top: 4rem;
    padding-bottom: 4rem;
    border-bottom: solid 0.2rem var(--lightBlue);
    .my-photo {
      width: 20rem;
      height: auto;
    }
    p {
      font-weight: bold;
      color: var(--darkBlue);
    }
    @media (min-width: 992px) {
      padding: 4rem 6rem;

      p {
        margin-left: 3rem;
      }
    }
  }

  .sect-2 {
    justify-content: flex-start;
    flex-wrap: wrap;
    a {
      text-decoration: none;
      color: var(--mainColor);
    }
    h4 {
      margin-top: 0.2rem;
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      padding: 0;
    }
    li {
      list-style: none;
    }
    ul.recent-entries {
      width: 100%;
      align-items: space-around;
      justify-content: center;
      flex-direction: column;
      li.recent-entry {
        border-bottom: 0.1rem solid var(--mainColor);
        border-left: 0.1rem solid var(--mainColor);
        max-height: 24rem;
        margin: 1rem;
        width: 100%;
        display: flex;
        overflow: hidden;
        padding: 0.5rem;
        div.content {
          padding: 1rem;
          word-break: break-all;
          width: 100%;
        }
        .head{
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 80%;
          h4{
            font-size: 2rem;
            margin:0;
            padding: 0;
          }
          .logo-type {
          width: 3rem;
          height: auto;
        }
        }
      }
    }
    .tag {
      a {
        color: var(--white);
      }
    }

    @media (min-width: 992px) {
      ul.recent-entries {
        flex-direction: row;
        li.recent-entry {
          width: 45%;
        }
      }
    }

    @media (min-width: 1200px) {
      ul.recent-entries {
        flex-direction: row;
        li.recent-entry {
          width: 30%;
        }
      }
    }
  }

  .sect-3 {
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    h3 {
      margin-bottom: 0;
    }
    h4 {
      color: var(--darkBlue);
      margin: 0;
    }
    .areas {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      width: 100%;
      div.area-card {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 45rem;
        padding: 1rem;
        border-left: 0.1rem solid var(--mainColor);
        border-bottom: 0.1rem solid var(--mainColor);
        margin: 1%;

        div.card-title {
          display: flex;
          flex-direction: column;
          img {
            height: 5rem;
            width: auto;
          }
        }
      }
      @media (min-width: 992px) {
        div.area-card {
          width: 45%;
          height: 42rem;
        }
      }
      @media (min-width: 1200px) {
        div.area-card {
          width: 23%;
          height: 42rem;
        }
      }
    }
  }

  .sect-4 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h2 {
      font-size: 2.4rem;
      text-align: center;
    }
    hr {
      border-color: var(--mainColor);
    }
  }
`;

export default Home;
